<template>
  <div class="Navbar elevationShadow--2">
    <div class="container container--relative">
      <a
        class="Navbar__logo"
        href="./"
      >
        <img
          src="~@/assets/img/logos/rae-logo.png"
          alt="RAE Logo"
        >
      </a>

      <div class="Navbar__navigationDrawerToggler">
        <i
          class="fas fa-bars"
          @click="showNavigationDrawer"
        />
      </div>

      <ModalSide
        :class="{ active: navigationDrawerIsVisible }"
        side="right"
        @hideModalSide="hideNavigationDrawer($event)"
      >
        <LanguageSelector slot="header" />
        <NavigationDrawer slot="body" />
      </ModalSide>
    </div>
  </div>
</template>

<script>
import ModalSide from '@/components/modal/Side.vue';
import NavigationDrawer from '@/components/navigation/Drawer.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';

export default {
  name: 'Navbar',
  components: {
    ModalSide,
    NavigationDrawer,
    LanguageSelector,
  },
  computed: {
    navigationDrawerIsVisible() {
      return this.$store.state.layout.navigationDrawerIsVisible;
    },
  },
  watch: {
    $route() {
      this.hideNavigationDrawer(false);
    },
  },
  methods: {
    showNavigationDrawer() {
      this.$store.commit('layout/TOGGLE_NAVIGATION_DRAWER', true);
      const bodyElement = document.getElementsByTagName('body')[0];
      bodyElement.style.overflow = 'hidden';
    },
    hideNavigationDrawer(val) {
      this.$store.commit('layout/TOGGLE_NAVIGATION_DRAWER', val);
      const bodyElement = document.getElementsByTagName('body')[0];
      bodyElement.style.overflow = 'auto';
    },
  },
};
</script>

<style scoped lang="scss">
.Navbar {
  height: 60px;
  background: #fff;
  @include z-index(navbar);
}
.Navbar__logo {
  display: block;
  @include absolute-center-y;
  height: 43px;

  img {
    @include img-fluid-y;
  }
}
.Navbar__navigationDrawerToggler {
  @include absolute-center-y;
  right: 0;
  padding-right: inherit;

  i {
    font-size: 24px;
    color: $color--primary;
    cursor: pointer;
    padding: 5px;
  }
}
@include media-lg() {
  .Navbar__logo {
    display: inline-block;
  }
}
</style>
